import React, {useState, useRef} from 'react';
import style from './Card.module.css'
/* swiper */
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Virtual } from "swiper/modules"
import "swiper/css";
import "swiper/css/navigation"
import "swiper/css/pagination"
import right_angle_selected from '../../images/right_angle_selected.svg'
import right_angle_unselected from '../../images/right_angle_unselected.svg'
import left_angle_selected from '../../images/left_angle_selected.svg'
import left_angle_unselected from '../../images/left_angle_unselected.svg'
import { useMediaQuery } from 'react-responsive'
import { useTranslation } from 'react-i18next'
import ko_data from '../../data/card/ko_card.js'
import en_data from '../../data/card/en_card.js'

function Card(props) {
  
  const [firstCardSwiper, setFirstCardSwiper] = useState(null);
  const [secondCardSwiper, setSecondCardSwiper] = useState(null);
  const [thirdCardSwiper, setThirdCardSwiper] = useState(null);
  const [firstCardIndex, setFirstCardIndex] = useState(0);
  const [secondCardIndex, setSecondCardIndex] = useState(0);
  const [thirdCardIndex, setThirdCardIndex] = useState(0);
  const isDesktop = useMediaQuery({ query: '(min-width: 769px)' })
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })


	// const [mainImageIndex, setMainImageIndex] = useState(0);
	const swiperParams = {
    pagenation: {
      clickable: true
    },
    loop: false,
    spaceBetween: 0,
    slidesPerView: 1, 
  };
  
	const { t, i18n } = useTranslation()
	let contents
  let lang
  if(i18n.language.indexOf("ko") > -1) {contents = ko_data; lang='ko'}
  else {contents = en_data; lang='en'}

	return (
		<div className='inner'>
      {/* ### 1 ### */}
			<div className={`${style.card_section}`}>			
				<div className={`${style.card_section_left}`}>
          {
            lang === 'ko'
            ?
            <div>
              <div className={`${style.card_section_left_header}`}>
                <span>{contents[0].title[0]}</span>
              </div>
              <div className={`${style.card_section_left_header}`}>
                <span>{contents[0].title[1]}</span>
              </div>
              <div className={`${style.card_section_left_header}`}>
                <span className={`${style.card_blue}`}>{contents[0].title[2]}</span>
              </div>
            </div>
            : 
            <div>
              <div className={`${style.card_section_left_header}`}>
                <span className={`${style.card_blue}`}>{contents[0].title[0]}</span>
              </div>
              <div className={`${style.card_section_left_header}`}>
                <span>{contents[0].title[1]}</span>
              </div>
              <div className={`${style.card_section_left_header}`}>
                <span>{contents[0].title[2]}</span>
              </div>
            </div>
          }
          {
            isDesktop
            ? 
            <div className={`${style.card_section_selector}`}>
              {
                contents[0].sub.map((ele, idx, arr)=>{
                  return (
                    <div key={idx} className={`${style.selector_sentence}`} onClick={(e)=>{firstCardSwiper.slideTo(idx); setFirstCardIndex(idx); console.log(firstCardIndex)}}>
                      <span>{ele}</span>
                      <img className={`${style.right_angle}`} src={ idx === firstCardIndex ? right_angle_selected : right_angle_unselected} alt=""/>
                  </div>    
                  )
                })
              }
            </div>
            : ''
          }
        </div>
				<div className={`${style.card_section_right} card_bullet`}>
          <Swiper {...swiperParams} onSwiper={setFirstCardSwiper} onSlideChange={(e)=>{setFirstCardIndex(e.activeIndex)}} className={style.swiper} pagination={{ clickable: true }}>
            {createSwiperSlide(contents[0])}
          </Swiper>
          {
            isMobile 
            ?
            <div className={`${style.card_section_selector}`}>
              {
                contents[0].sub.map((ele, idx, arr)=>{
                  return (
                    <div key={idx} className={`${style.selector_sentence}`} onClick={(e)=>{firstCardSwiper.slideTo(idx); setFirstCardIndex(idx); console.log(firstCardIndex)}}>
                      <span>{ele}</span>
                      <img className={`${style.right_angle}`} src={ idx === firstCardIndex ? right_angle_selected : right_angle_unselected} alt=""/>
                    </div>    
                  )
                })
              }
            </div>
            : ''
          }
				</div>
      </div>
      {/* ### 2 ### */}
      <div className={`${style.card_section}`}>			
				<div className={`${style.card_section_left}`}>
          {
            isDesktop
            ?
            <Swiper {...swiperParams} allowTouchMove={false} onSwiper={setSecondCardSwiper} onSlideChange={(e)=>{setFirstCardIndex(e.activeIndex)}} className={style.swiper} pagination={{ clickable: true }}>
              { createSwiperSlide(contents[1]) }
            </Swiper>
            : lang === 'ko'
              ?
              <div className={`${style.card_section_right_second}`}>
                <div className={`${style.card_section_right_header}`}>
                  <span>{contents[1].title[0]}</span>
                  <span className={`${style.card_blue}`}>{contents[1].title[1]}</span>
                  <span>{contents[1].title[2]}</span>
                </div>
                <div className={`${style.card_section_right_header}`}>
                  <span>{contents[1].title[3]}</span>
                </div>
                <div className={`${style.card_section_right_header}`}>
                  <span className={`${style.card_blue}`}>{contents[1].title[4]}</span>
                </div>
              </div>
              : 
              <div className={`${style.card_section_right_second}`}>
                <div className={`${style.card_section_right_header}`}>
                  <span className={`${style.card_blue}`}>{contents[1].title[0]}</span>
                  <span>{contents[1].title[1]}</span>
                </div>
                <div className={`${style.card_section_right_header}`}>
                  <span className={`${style.card_blue}`}>{contents[1].title[2]}</span>
                </div>
                <div className={`${style.card_section_right_header}`}>
                  <span>{contents[1].title[3]}</span>
                </div>
              </div>
          }
				</div>
				<div className={`${style.card_section_right}`}>
          {
            isMobile
            ?
            <Swiper {...swiperParams} allowTouchMove={false} onSwiper={setSecondCardSwiper} onSlideChange={(e)=>{setFirstCardIndex(e.activeIndex)}} className={style.swiper} pagination={{ clickable: true }}>
              { createSwiperSlide(contents[1]) }
            </Swiper>
            : 
            lang === 'ko'
              ?
              <div className={`${style.card_section_right_second}`}>
                <div className={`${style.card_section_right_header}`}>
                  <span>{contents[1].title[0]}</span>
                  <span className={`${style.card_blue}`}>{contents[1].title[1]}</span>
                  <span>{contents[1].title[2]}</span>
                </div>
                <div className={`${style.card_section_right_header}`}>
                  <span>{contents[1].title[3]}</span>
                </div>
                <div className={`${style.card_section_right_header}`}>
                  <span className={`${style.card_blue}`}>{contents[1].title[4]}</span>
                </div>
              </div>
              : 
              <div className={`${style.card_section_right_second}`}>
                <div className={`${style.card_section_right_header}`}>
                  <span className={`${style.card_blue}`}>{contents[1].title[0]}</span>
                  <span>{contents[1].title[1]}</span>
                </div>
                <div className={`${style.card_section_right_header}`}>
                  <span className={`${style.card_blue}`}>{contents[1].title[2]}</span>
                </div>
                <div className={`${style.card_section_right_header}`}>
                  <span>{contents[1].title[3]}</span>
                </div>
              </div>
          }
					<div className={`${style.card_section_selector}`}>
            {
              contents[1].sub.map((ele, idx, arr)=>{
                return (
                  isDesktop
                  ?
                  <div key={idx} className={`${style.selector_sentence}`} onClick={(e)=>{e.preventDefault();}}>
                    <img className={`${style.left_angle}`} src={ left_angle_selected } alt=""/>                    
                    <span className={`${style.left_sentennce}`}>{ele}</span>
                  </div>
                  :
                  <div key={idx} className={`${style.selector_sentence}`} onClick={(e)=>{e.preventDefault();}}>
                    <span className={`${style.left_sentennce}`}>{ele}</span>
                    <img className={`${style.right_angle}`} src={ right_angle_selected } alt=""/>                    
                  </div>
                )
              })
            }
					</div>
				</div>
			</div>

      {/* ### 3 ### */}
      <div className={`${style.card_section}`}>			
				<div className={`${style.card_section_left}`}>
          {
            lang === 'ko'
            ?
            <div>
              <div className={`${style.card_section_left_header}`}>
                <span>{contents[2].title[0]}</span>
              </div>
              <div className={`${style.card_section_left_header}`}>
                <span>{contents[2].title[1]}</span>
              </div>
              <div className={`${style.card_section_left_header}`}>
                <span className={`${style.card_blue}`}>{contents[2].title[2]}</span>
              </div>
            </div>
            :
            <div>
              <div className={`${style.card_section_left_header}`}>
                <span className={`${style.card_blue}`}>{contents[2].title[0]}</span>
              </div>
              <div className={`${style.card_section_left_header}`}>
                <span>{contents[2].title[1]}</span>
              </div>
              <div className={`${style.card_section_left_header}`}>
                <span>{contents[2].title[2]}</span>
              </div>
            </div>
          } 
          {
            isDesktop
            ? 
            <div className={`${style.card_section_selector}`}>
              <div className={`${style.selector_sentence}`} onClick={(e)=>{thirdCardSwiper.slideTo(0); setThirdCardIndex(0);}}>
                <span>{contents[2].sub[0]}</span>
                <img className={`${style.right_angle}`} src={ 0 === thirdCardIndex ? right_angle_selected : right_angle_unselected } alt=""/>
              </div>
              <div className={`${style.selector_sentence}`} onClick={(e)=>{thirdCardSwiper.slideTo(1); setThirdCardIndex(1);}}>
                <span>{contents[2].sub[1]}</span>
                <img className={`${style.right_angle}`} src={ 1 === thirdCardIndex ? right_angle_selected : right_angle_unselected } alt=""/>
              </div>   
              <div className={`${style.selector_sentence_lines}`} onClick={(e)=>{thirdCardSwiper.slideTo(2); setThirdCardIndex(2);}}>
                <span>{contents[2].sub[2]}<br/>{contents[2].sub[3]}<br/>{contents[2].sub[4]}</span>
                <img className={`${style.right_angle}`} src={ 2 === thirdCardIndex ? right_angle_selected : right_angle_unselected } alt=""/>
              </div> 
            </div>
            : ''
          }
        </div>
					
				<div className={`${style.card_section_right_third}`}>
          <Swiper {...swiperParams} onSwiper={setThirdCardSwiper} onSlideChange={(e)=>{setThirdCardIndex(e.activeIndex)}} className={style.swiper} pagination={{ clickable: true }}>
            { createSwiperSlide(contents[2]) }
          </Swiper>
					{
            isMobile 
            ?
            <div className={`${style.card_section_selector}`}>
              <div className={`${style.selector_sentence}`} onClick={(e)=>{thirdCardSwiper.slideTo(0); setThirdCardIndex(0);}}>
                <span>{contents[2].sub[0]}</span>
                <img className={`${style.right_angle}`} src={ 0 === thirdCardIndex ? right_angle_selected : right_angle_unselected } alt=""/>
              </div>
              <div className={`${style.selector_sentence}`} onClick={(e)=>{thirdCardSwiper.slideTo(1); setThirdCardIndex(1);}}>
                <span>{contents[2].sub[1]}</span>
                <img className={`${style.right_angle}`} src={ 1 === thirdCardIndex ? right_angle_selected : right_angle_unselected } alt=""/>
              </div>   
              <div className={`${style.selector_sentence_lines}`} onClick={(e)=>{thirdCardSwiper.slideTo(2); setThirdCardIndex(2);}}>
                <span>{contents[2].sub[2]}<br/>{contents[2].sub[3]}</span>
                <img className={`${style.right_angle}`} src={ 2 === thirdCardIndex ? right_angle_selected : right_angle_unselected } alt=""/>
              </div>  
            </div>
            : ''
          }
				</div>
			</div>
		</div>
	);
}

function createSwiperSlide(content){
  return (
    content.img.map((ele, idx)=>{
      return(
        <SwiperSlide key={ele}>
          <img className={`${style.card_img}`} src={ele} alt=''/>
        </SwiperSlide>
      )
    })
  )
}

export default Card;